var BaseView = require('../components/accordion-list/content');
var AnalyticsDecorate = require('../../../analytics/decorate');
var TextBannerThumbnailView = require('../components/thumbnail/text-banner');

module.exports = AnalyticsDecorate(require('./analytics/banners'), BaseView.extend({
  apiCall: 'search/stickers',
  limit: 30,
  thumbnailViews: [],
  callbackName: 'callbackStickers',

  initialize: function () {
    INKIVE.C.IS_MOBILE && this.show();
    this.debouncedMasonryReload = _.debounce(_.bind(this.masonryReload, this), 800);
  },

  show: function () {
    this.isAlreadyThere || BaseView.prototype.initialize.call(this);
    this.isAlreadyThere = true;
  },

  refresh: function () {
    _.invoke(this.thumbnailViews, 'resize');
  },

  render: function () {
    BaseView.prototype.render.call(this);
    this.$el.find('.thumbnail-wrapper').masonry();
  },

  getParams: function () {
    var params = {
      from: this.from,
      limit: this.limit,
      where: {
        active: INKIVE.C.USER.IS_SUPER ? 0 : 1,
        isText: 1
      }
    };

    this.from += this.limit;

    return params;
  },

  getScrollHeight: function ($target) {
    var $tabContent = $target.closest('.tab-content');
    var containerHeight = $tabContent.height();

    containerHeight -= $tabContent.find('.header-links').height();

    return containerHeight;
  },

  appendThumbnails: function (data) {
    var $wrapper = this.$el.find('.thumbnail-wrapper');
    var $scrollDetect = $wrapper.find('.scrollDetect');

    _.each(data, function (svg) {
      if (!svg['url']) return;

      var $thumbnailView = $('<div>').addClass('thumbnail svg')
        .data('key', svg['id'])
        .insertBefore($scrollDetect);

      var textBannerThumbnailView = new TextBannerThumbnailView({
        el: $thumbnailView,
        svg: svg
      });

      $wrapper.masonry('appended', $thumbnailView);
      textBannerThumbnailView.on('resize', this.debouncedMasonryReload);
      this.thumbnailViews.push(textBannerThumbnailView);
    }, this);
  }
}));
